import { Badge, Flex, Tabs } from '@chakra-ui/react';
import type { NavItem } from './navigationData';
import { NavLink } from 'react-router-dom';

type NavTabsProps = {
    navItems: NavItem[];
    activeTab: string;
    size?: 'sm' | 'md';
    display?: object | string;
    justifyContent?: 'left' | 'center';
    flex?: number;
    className?: string;
};

export function NavTabs({
    navItems,
    activeTab,
    size = 'md',
    display,
    justifyContent = 'left',
    flex = 1,
}: NavTabsProps) {
    const renderTabTrigger = (item: NavItem) => (
        <Tabs.Trigger
            key={item.href}
            value={item.href}
            pb={2}
            px={7}
            color="gray.700"
            fontWeight={700}
            _hover={{ color: 'orange.500', textDecoration: 'none' }}
            _selected={{ color: 'orange.500', borderColor: 'orange.500' }}
        >
            <Flex align="center" gap={2}>
                <span>{item.label}</span>
                {typeof item.badgeValue === 'number' && (
                    <Badge
                        colorPalette="orange"
                        variant="subtle"
                        borderRadius="full"
                        px={2}
                        py={0.5}
                        fontSize="xs"
                    >
                        {item.badgeValue}
                    </Badge>
                )}
            </Flex>
        </Tabs.Trigger>
    );

    return (
        <Tabs.Root
            size={size}
            variant="line"
            colorScheme="orange"
            display={display}
            flex={flex}
            justifyContent={justifyContent === 'center' ? 'center' : 'flex-start'}
            value={activeTab}
        >
            <Tabs.List
                gap={2}
                borderColor="transparent"
                overflowX={size === 'sm' ? 'auto' : undefined}
                whiteSpace={size === 'sm' ? 'nowrap' : undefined}
            >
                {navItems.map((item) => (
                    item.href.startsWith('#') ? (
                        <a key={item.href} href={item.href} style={{ fontWeight: 700, textDecoration: 'none' }}>
                            {renderTabTrigger(item)}
                        </a>
                    ) : (
                        <NavLink
                            key={item.href}
                            to={item.href}
                            style={{ textDecoration: 'none', display: 'contents' }}
                        >
                            {renderTabTrigger(item)}
                        </NavLink>
                    )
                ))}
            </Tabs.List>
        </Tabs.Root>
    );
}
